import React from 'react';
import { DealFlowNavbar } from './DealFlowNavbar';
import { DealFlowFooter } from './DealFlowFooter';
export function DealFlowLayout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex flex-col min-h-screen bg-charcoal-dark text-white font-sans selection:bg-gold selection:text-charcoal-dark" data-id="element-327" data-mp="284krtpcsz0xn">
      <DealFlowNavbar data-id="element-328" data-mp="23dcfolk391gs" />
      <main className="flex-grow" data-id="element-329" data-mp="23c1b4jitjpom">{children}</main>
      <DealFlowFooter data-id="element-330" data-mp="2h4rb5rv6mv4q" />
    </div>;
}